import DOMPurify from "dompurify";

// Only allow the tags/attributes our chapter renderers actually emit.
const CONFIG = {
  ALLOWED_TAGS: ["strong", "em", "br"],
  ALLOWED_ATTR: [],
};

/** Sanitize an HTML string that was assembled by our own inline-markdown
 *  renderer. Belt-and-suspenders even though the renderer already escapes
 *  <, >, & before injecting <strong>/<br>. */
export function safeHtml(html) {
  return DOMPurify.sanitize(String(html ?? ""), CONFIG);
}
